// src/components/ProcessSteps.jsx
// Os quatro passos "Como funciona", compartilhados entre Home e Sobre.
import "./ProcessSteps.css";

export const STEPS = [
  {
    n: "01",
    title: "Agendamento",
    desc: "Você manda o endereço pelo WhatsApp e escolhe o pacote. Confirmamos data e horário.",
  },
  {
    n: "02",
    title: "Captação",
    desc: "Nosso piloto e fotógrafo vai ao imóvel com drone, câmera e estabilizador.",
  },
  {
    n: "03",
    title: "Edição",
    desc: "Cor, corte, trilha e tratamento das fotos pela nossa equipe de pós-produção.",
  },
  {
    n: "04",
    title: "Entrega",
    desc: "Link do material em até 48h, nos formatos certos para cada canal.",
  },
];

function ProcessSteps() {
  return (
    <div className="container process-grid">
      {STEPS.map((s) => (
        <div key={s.n} className="process-step">
          <span className="process-n">{s.n}</span>
          <h3>{s.title}</h3>
          <p>{s.desc}</p>
        </div>
      ))}
    </div>
  );
}

export default ProcessSteps;
